<template>

    <div>
        <Loading/>
        <MenuInternoCadastros/>
        <span><strong>- ÁREAS <i class="fas fa-chevron-right"></i> LISTAGEM
      <span v-if="paginaTop != ''"><i class="fas fa-chevron-right"></i> {{paginaTop}}</span></strong></span>

        <div v-if="listagem == 'listagem'">
            <div class="text-right mb-2">
                <button class="btn btn-sm btn-success" @click="viewAdicionar">Adicionar Área</button>
            </div>
            <!-- <div style="height:700px;">
              <div id="grid-areas" style="width:100%; height:100%; background-color:white;"></div>
            </div> -->
            <!-- {{dados}} -->
            <table id="tabela" class="table table-striped table-responsive-sm">
                <thead>
                <tr>
                    <th>Id</th>
                    <th class="text-center">Descrição</th>
                    <th class="text-center">Ações</th>

                </tr>
                </thead>
            </table>

        </div>
        <div v-else-if="listagem == 'cadastro'">
            <AreasCadastro/>
        </div>
        <div v-else-if="listagem == 'editar'">
            <AreasEditar :id='id'/>
        </div>
    </div>

</template>

<script>
    import Loading from '../login/Loading'
    import MenuInternoCadastros from '../menu-interno/MenuInternoCadastros.vue'
    import AreasCadastro from '../areas/AreasCadastro.vue'
    import AreasEditar from '../areas/AreasEditar.vue'

    // var gridArea;

    export default {
        name: 'AreasListagem',
        components: {
            Loading,
            MenuInternoCadastros,
            AreasCadastro,
            AreasEditar
        },
        data() {
            return {
                // isModalVisible: false,
                listagem: 'listagem',
                paginaTop: '',
                id: '',
                dados: ''
            }
        },
        methods: {
            viewAdicionar() {
                this.listagem = 'cadastro',
                    this.paginaTop = 'ADICIONAR ÁREA',
                    $('#tabela').parents('div.dataTables_wrapper').first().hide();
            }

        },
        mounted: function () {
            let thiss = this;
            let swall = this.$swal;

            let tabela = $('#tabela').DataTable({
                "oLanguage": {
                    "sSearch": "Pesquisar:",
                    "sEmptyTable": "Nenhum dado para exibição",
                    "sZeroRecords": "Nenhum dado encontrado",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                    },
                    "sLengthMenu": "Mostrar _MENU_ dados",
                    "sInfoFiltered": " - (filtrado de _MAX_ dados)",
                    "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ dados",
                },
                "ajax": {
                    "url": axios.defaults.baseURL+"/api/sist-obras/areas",
                    dataSrc: '',
                    headers: {
                        'Authorization': `Bearer ${Store.getters.pegaAccessToken}`
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        API.geraNovoTokenDatatable(jqXHR, tabela);
                    }
                },
                "columns": [
                    {"data": "c03_id", visible: false},
                    {"data": "c03_descr"},
                    {
                        targets: [2],
                        width: '10%',
                        orderable: false,
                        mData: data => criarBotoes(data.c03_id)
                    }
                ],
                'fnDrawCallback': function () {

                    $('.editar').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;
                        thiss.listagem = 'editar'
                        thiss.paginaTop = 'EDITAR'
                        $('#tabela').parents('div.dataTables_wrapper').first().hide();
                    })
                    $('.excluir').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;

                        swall({
                            title: "Atenção!",
                            text: "Deseja realmente excluir o Tipo de Área selecionada?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: 'Sim',
                            cancelButtonText: "Não!"
                        })
                            .then(
                                function () {
                                    API.enviarRequisicao('delete', '/api/sist-obras/areas/' + thiss.id)
                                        .then( resp => {
                                            swall('Atenção', 'Área deletada com sucesso', 'success')
                                                .then(
                                                    function () {
                                                        history.go(0);
                                                    }
                                                )
                                        })
                                        .catch(error => {
                                            swall('Erro', 'A Área esta sendo usado em Obras', 'error')
                                        });
                                },
                                function () {
                                    return false;
                                });

                    })

                }
            });


            function criarBotoes(id, ctrl) {
                if (ctrl != null) {
                    return '<a href="#" class="btnEditar' + ctrl + ' btn btn_editar_rh btn-default btn-sm">' +
                        '<i class="fa fa-edit" data-toggle="tooltip" title="Editar"></i>' +
                        '</a>' +
                        '<a href="#" data-id="' + id + '" class="btn btn-sm btn-info' + ctrl + ' btn btn-default btn-sm">' +
                        '<i class="fa fa-trash" data-toggle="tooltip" title="Deletar"></i>' +
                        '</a>';
                } else {
                    return "<button class='btn btn-sm editar' data-id='" + id + "'><i class='fa fa-edit text-info' ></i></button>" +
                        "<button class='btn btn-sm excluir' data-id='" + id + "'><i class='fa fa-trash text-danger'></i></button>";
                }
            }

            // axios
            //   .get('http://192.168.1.17:8085/api/sist-obras/areas')
            //   .then(response => {
            //     this.dados = response.data
            // })
            //     gridArea.parse(this.dados, "json")

            //     let thiss = this
            //     let swall = this.$swal
            //     $('.hdrcell').css('text-align', 'center')

            //     $('.editar').on('click', function(){
            //       var dados = $(this).data('id')
            //       thiss.id = dados;
            //       thiss.listagem = 'editar'
            //       thiss.paginaTop = 'EDITAR'
            //     })

            //     $('.excluir').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;

            //       swall({
            //         title: "Atenção!",
            //         text: "Deseja realmente excluir o Tipo de Área selecionada?",
            //         type: "warning",
            //         showCancelButton: true,
            //         confirmButtonText: 'Sim',
            //         cancelButtonText: "Não!"
            //       })
            //       .then(
            //           function () {
            //             axios
            //             .delete("http://192.168.1.17:8085/api/sist-obras/areas/"+thiss.id)
            //             .then(
            //                swall('Atenção', 'Área deletada com sucesso', 'success')
            //                .then(
            //                   function () {
            //                     history.go(0);
            //                   }
            //                 )
            //             )
            //             .catch(error => {
            //               swall('Erro', 'A Área esta sendo usado em Obras', 'error')
            //             });
            //           },
            //           function () {
            //             return false;
            //           });

            //     })
            //   })

            // gridArea = new dhtmlXGridObject('grid-areas');
            // gridArea.setImagePath("libs/imgs/");
            // gridArea.setHeader("Código, Descrição, Ações");
            // gridArea.setInitWidths("70,850,105");
            // gridArea.setColAlign("left,left, left");
            // gridArea.setColTypes("ro,ro,ro");
            // gridArea.setColSorting("na,str");

            // gridArea.init();
            // gridArea.attachEvent("onRowCreated",function(id){
            //     this.cells(id,2).setValue("<button class='btn btn-sm editar' data-id='"+id+"'><i class='fa fa-edit text-info' ></i></button><button class='btn btn-sm excluir' data-id='"+id+"'><i class='fa fa-trash text-danger'></i></button>");
            //     return true;
            // });
            // gridArea.attachHeader("&nbsp;,#text_filter");
            // // gridArea.enableSmartRendering(true, 50);
            // gridArea.setColumnHidden(0,true);


        }

    }


</script>

<style scoped>

    h2 {
        color: #5377C1;
    }

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }


</style>
